import React, { useEffect, useState } from 'react';
import {
  Spin,
  Space,
  Row,
  Col,
  Card,
  Tooltip,
  Table,
  notification,
  Input,
  Modal,
  Button
} from 'antd';
import { history } from '../../redux/store';
import axios from 'axios';
import moment from 'moment';
import _ from 'underscore';
import setting from '../../config/setting';

const DriversQualificationFront = () => {
  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const [driverResponse, setDriverResponse] = useState([]);
  // const [driverAll, setDriverAll] = useState([]);
  const [change, setChange] = useState(false);
  const [driverRecentResponse, setDriverRecentResponse] = useState([]);
  const [driverStatus, setDriverStatus] = useState([]);
  var certificateTypes =[
    "Driver’s Application",
    "Commercial Driver's License (CDL)",
    'DOT Clearinghouse',
    'Initial Driving Record (MVR)',
    "CDLIS (Commercial Driver's License Information Search)",
    'PSP Search',
    'Previous-Employer Information',
    'Road Test Form and Certificate',
    'DOT Medical Card (Medical Examiner Certificate)',
    'Annual Motor Vehicle Report (MVR)',
    "Driver's Certification of Violations/Annual Review",
    'Entry-level Driver Training Certificate',
    'Longer-combination Vehicle Training Certificate'
          ]
  useEffect(() => {
    getData();
  }, []);

  function getData() {
    let employeeData = JSON.parse(localStorage.getItem('employeeInfo'));
    setIsLoaderActive(true);
    axios
      .post(setting.serverUrl + '/api/getLatestRecordForDriver', {
        params: {
          email: localStorage.getItem('myData'),
          user: localStorage.getItem('myData'),
          // pass: localStorage.getItem('myPass'),
          customerId: employeeData ? employeeData.company[0] : '',
          employeeId: employeeData ? employeeData.id : ''
        }
      })
      .then((response) => {
        setChange(!change);
        if (response && response.status == 200) {
          let result = response.data.rows;
          // let groupById = _.groupBy(result, 'employee');
          // let groupedByIdData = parseGroupRecords(groupById);
         
          setIsLoaderActive(false);
          setDriverRecentResponse(result);
          //setDriverResponse(groupedByIdData);
          // let resultCertKey = result.cert_type;
          // let resultStatusKey = result.status;
          // let resultExpKey = result.cert_exp;
          // for (var i = 0; i <=certificateTypes.length; i++ )
          // {
          //   if(certificateTypes[i] == resultCertKey)
          //   return 
          // }

//           let fresult = findByMatchingProperties(result,certificateTypes)
//           function findByMatchingProperties(set, properties) {
//             return set.filter(function (entry) {
//                 return Object.keys(properties).every(function (key) {
//                     return entry[key] === properties[key];
//                 });
//             });
//         }
          // var item;
          // if( result.hasOwnProperty(myString) ) {
          //     item = result[myString];
          // }
          // let parseData = parseRecord(result);
          // setDriverStatus(parseData);
          //setDriverResponse(result);

          //   let data = response.data;
          //   let parsedData = data.map((item) => {
          //     return { ...item, ...parseRecord(item) };
          //   });

          //setDriverResponse(parsedData);
          //setChange(!change);
          //let total = response.data;
          //   setDriverAll(total);
          //   setDriverAllLength(response.data.length);
          //   setDriverEvent(response.data);
        } else {
          notification['error']({
            message: 'Error',
            description: 'There is some technical issue. Please try again later.'
          });
        }
      });
  }
  // function getDateOnly(date = new Date()) {
  //   const currentDate = date;
  //   const currentDayOfMonth = currentDate.getDate();
  //   const currentMonth = currentDate.getMonth();
  //   const currentYear = currentDate.getFullYear();
  //   const noTimeDate = new Date(currentYear, currentMonth, currentDayOfMonth, 0, 0, 0);
  //   return noTimeDate;
  // }

  // function convertIntoTimeStamp(date) {
  //   return date.getTime();
  // }

  // function getTwoDayBefore() {
  //   return convertIntoTimeStamp(getPreviousDay(getDateOnly()));
  // }

  // function getCurrentTimeStamp() {
  //   return convertIntoTimeStamp(getDateOnly());
  // }

  // function getPreviousDay(date = new Date()) {
  //   const previous = new Date(date.getTime());
  //   previous.setDate(date.getDate() - 30);

  //   return previous;
  // }

  // function isExpiring(certDate) {
  //   const certTimeStamp = convertIntoTimeStamp(getDateOnly(new Date(certDate)));
  //   const previousTimeStamp = getTwoDayBefore();
  //   const currentTimeStamp = getCurrentTimeStamp();
  //   return previousTimeStamp <= certTimeStamp && currentTimeStamp > certTimeStamp;
  // }

  // function isExpired(certDate) {
  //   const certTimeStamp = convertIntoTimeStamp(getDateOnly(new Date(certDate)));
  //   const previousTimeStamp = getTwoDayBefore();
  //   return previousTimeStamp > certTimeStamp;
  // }

  // function isActive(certDate) {
  //   const certTimeStamp = convertIntoTimeStamp(getDateOnly(new Date(certDate)));
  //   const currentTimeStamp = getCurrentTimeStamp();
  //   return currentTimeStamp < certTimeStamp;
  // }
  // function parseRecord(record) {
  //   let expiring = {};
  //   let active = {};
  //   let exempt = {};
  //   let status = {};
  //   let incomplete = {};
  //   let keys = Object.keys(record);
  //   //let values = Object.values(record);
  //   for (let i = 0; i < keys.length; i++) {
  //     const key = keys[i];
  //     //const value = keys[value];
  
  //     // if (
  //     //   key === 'cargo_edu' ||
  //     //   key === 'driver_certifications' ||
  //     //   key === 'commercial_vehicle' ||
  //     //   key === 'road_test' ||
  //     //   key === 'cdl_exp'
  //     // ) 
  //     // {
  //     //   if (key && key == undefined) {
  //     //     status[key] = 1;
  //     //   } else {
  //     //     if (isExpiring(record[key]) === true) {
  //     //       status[key] = 'Expires ' + moment(record[key]).format('MM/DD/YYYY');
  //     //     }
  //     //     if (isActive(record[key]) === true) {
  //     //       status[key] = <b>{'Active until ' + moment(record[key]).format('MM/DD/YYYY')} </b>;
  //     //     }
  //     //     if (isExpired(record[key]) === true) {
  //     //       status[key] = (
  //     //         <b style={{ color: 'red' }}>
  //     //           {'Expired ' + moment(record[key]).format('MM/DD/YYYY')}
  //     //         </b>
  //     //       );
  //     //     }
  //     //   }
  //     // }
  //   }
  //   return status;
  // }
  // function parseGroupRecords(data) {
  //   const keys = Object.keys(data);
  //   let driverRecords = [];
  //   for (let i = 0; i < keys.length; i++) {
  //   const key = keys[i];
  //   const records = data[key];
  //   if (records.length > 0) {
  //   let record = records[0];
  //   record['Incomplete'] = [];
  //   record['Active'] = [];
  //   record['Exempted'] = [];
  //   record['Expiring'] = [];
   
  //   for (let i = 0; i < records.length; i++) {
  //   const rec = records[i];
  //   const object = {
  //   cert_exp: moment(rec.cert_exp).format('MM/DD/YYYY'),
  //   cert_type: rec.cert_type
  //   };
  //   if (rec.status === 'Incomplete') {
  //   record['Incomplete'].push(object);
  //   record[rec.cert_type] =
  //  //  'Incomplete '+ " " + moment(rec.cert_exp).format('MM/DD/YYYY');
  //  <b style= {{color: "#ffa618"}}>Incomplete</b>
  //   } else if (rec.status === 'Completed') {
  //   record['Active'].push(object);
  //   record[rec.cert_type] = 'Active until' + moment(rec.cert_exp).format('MM/DD/YYYY');
  //   } else if (rec.status === 'Exempted') {
  //   record['Exempted'].push(object);
  //   record[rec.cert_type] =
  //   <b style= {{color: "#87ce8d"}}>Exempt</b>
  //   } else if (rec.status === 'Expired') {
  //   record['Expiring'].push(object);
  //   record[rec.cert_type] =
  //   <b style= {{color: "#f26565"}}>Expired</b> + moment(rec.cert_exp).format('MM/DD/YYYY');
  //   }
  //   }
  //   driverRecords.push(record);
  //   }
  //   }
  //   return driverRecords;
  //   }
  function showDriverQualificationHistory() {
    history.push({ pathname: `/vertical/DriverQualification`, state: {} });
  }
  function createDriverQualification() {
    history.push({ pathname: `/vertical/addDriverQualification`, state: {} });
  }
  const columns = [
    {
      key: 'cert_type',
      dataIndex: 'cert_type',
      title: "Certificates",
      sorter: (a, b) => a.cert_type.length - b.cert_type.length,
        // moment(a.driver_certifications).unix() - moment(b.driver_certifications).unix(),

      render: (cert_type) => (
        <span className='nowrap'>
          <strong>
            {cert_type}
            {/* {driver_certifications ? moment(driver_certifications).format('MM/DD/YYYY') : ''} */}
          </strong>
        </span>
      )
    },
    {
      key: 'cert_exp',
      dataIndex: 'cert_exp',
      title: 'Certificate Expiration',
      sorter: (a, b) => moment(a.cert_exp).unix() - moment(b.cert_exp).unix(),

      render: (cert_exp) => (
        <span className='nowrap'>
          <strong>
            {' '}
            {cert_exp ? moment(cert_exp).format('MM/DD/YYYY') : ''}
          </strong>
        </span>
      )
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: 'Status',
     // sorter: (a, b) =>(a.status.length-b.status.length),

      render: (status) => (
        <span className='nowrap'>
          {/* {status} */}
          {status === 'Incomplete' ? (
                      <b style={{ color: '#ffa618' }}>{status}</b>
                    ) : status === 'Exempted' ? (
                      <b style={{ color: '#6c6' }}>Exempt</b>
                    ) : status === 'Expired' ? (
                      <b style={{ color: '#f55' }}>{status}</b>
                    ) : status === 'Completed' ? (
                      <b style={{ color: '#f62' }}>Active</b>
                    ) : (
                      <b>{status}</b>
                    )}
          {/* <strong> {cargo_edu ? moment(cargo_edu).format('MM/DD/YYYY') : ''}</strong> */}
        </span>
      )
    },


    // {
    //   key: 'attachment_id',
    //   dataIndex: 'attachment_id',
    //   title: 'Authorization',
    //   render: (attachment_id) => (
    //     <span className='nowrap'>
    //       {attachment_id && attachment_id.length > 0 ? (
    //         <button className='doclink' onClick={(e) => download(e, [attachment_id])}>
    //           Preview
    //         </button>
    //       ) : (
    //         ''
    //       )}
    //     </span>
    //   )
    // }
  ];
  return (
    <div style={{ padding: 30 }}>
      <Row>
        <Col span={12}>
          <h3 style={{ padding: 10, textAlign: 'left' }}>
            Driver Qualifications - Employee Portal
          </h3>
        </Col>

        <Col span={3}></Col>
        <Col span={2}>
          <Button
            style={{ marginTop: 20, backgroundColor: '#379' }}
            onClick={() => createDriverQualification()}
          >
           Add Certificate(s)
          </Button>
        </Col>
        <Col span={2}></Col>
        <Col span={2}>
          <Button
            style={{ marginTop: 20, backgroundColor: '#379' }}
            onClick={() => showDriverQualificationHistory()}
          >
            Driver History
          </Button>
        </Col>
        <Col span={3}></Col>
      </Row>

      {driverRecentResponse && !isLoaderActive ? (
        // <div style={{ backgroundColor: 'white', width: '100%', height: '100%', borderRadius: 15 }}>
        //   <Row
        //     style={{
        //       backgroundColor: '#2f7197',
        //       color: '#fff',
        //       borderTopLeftRadius: 15,
        //       borderTopRightRadius: 15
        //     }}
        //   >
        //     <Col span={9}>
        //       <h6>Your requirements : </h6>
        //     </Col>
        //     <Col span={4}>
        //       <h6> Status : </h6>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>Driver’s Application : </b>
        //     </Col>
        //     <Col span={4}>
        //       <b>{driverStatus ? driverStatus['driver_certifications'] : ''}</b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b> Commercial Driver's License (CDL) : </b>
        //     </Col>
        //     <Col span={4}>
        //       <b>{driverStatus ? driverStatus['commercial_vehicle'] : ''}</b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>DOT Clearinghouse :  </b>
        //     </Col>
        //     <Col span={4}>
              
        //       <b>
        //         {' '}
        //         {driverResponse.vehicle_report ? (
        //           driverResponse.vehicle_report === 'Complete' ? (
        //             <b style={{ color: '#f62' }}>{driverResponse.vehicle_report}</b>
        //           ) : (
        //             <b style={{ color: 'Yellow' }}>{driverResponse.vehicle_report}</b>
        //           )
        //         ) : (
        //           ''
        //         )}
        //       </b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>Initial Driving Record (MVR) : </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>CDLIS (Commercial Driver's License Information Search) :  </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>PSP Search :  </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>Previous-Employer Information : </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>Road Test Form and Certificate : </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>DOT Medical Card (Medical Examiner Certificate) : </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>Annual Motor Vehicle Report (MVR) : </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>Driver's Certification of Violations/Annual Review : </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>Driver's Certification of Violations/Annual Review : </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>Entry-level Driver Training Certificate </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row>
        //   <Row>
        //     <Col span={9}>
        //       <b>Longer-combination Vehicle Training Certificate</b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row>
        //   {/* <Row>
        //     <Col span={9}>
        //       <b>Safety Performance History Records: Driver Correction or Rebuttal </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_history} </b>
        //     </Col>
        //   </Row> */}
        //   {/* <Row>
        //     <Col span={9}>
        //       <b> Cargo Education Training Acknowledgement </b>
        //     </Col>
        //     <Col span={4}>
        //       <b>{driverStatus ? driverStatus['cargo_edu'] : ''}</b>
        //     </Col>
        //   </Row> */}
        //   {/* <Row>
        //     <Col span={9}>
        //       <b> Certificate of Road Test or Equivalent</b>
        //     </Col>
        //     <Col span={4}>
        //       <b>{driverStatus ? driverStatus['road_test'] : ''}</b>
        //     </Col>
        //   </Row> */}
        //   {/* <Row>
        //     <Col span={9}>
        //       <b> FMCSA Training Acknowledgement </b>
        //     </Col>
        //     <Col span={4}>
        //       <b>
        //         {driverResponse.fmcsa_training ? (
        //           driverResponse.fmcsa_training === 'Complete' ? (
        //             <b style={{ color: '#f62' }}>{driverResponse.fmcsa_training}</b>
        //           ) : (
        //             <b style={{ color: 'Yellow' }}>{driverResponse.fmcsa_training}</b>
        //           )
        //         ) : (
        //           ''
        //         )}{' '}
        //       </b>
        //     </Col>
        //   </Row> */}
        //   {/* <Row>
        //     <Col span={9}>
        //       <b> Performance Evaluation </b>
        //     </Col>
        //     <Col span={4}>
        //       <b> {driverResponse.perform_eval ? driverResponse.perform_eval : ''} </b>
        //     </Col>
        //   </Row> */}
        //   {/* <Row>
        //     <Col span={9}>
        //       <b> Upcoming CDL Expiration</b>
        //     </Col>
        //     <Col span={4}>
        //       <b>{driverStatus ? driverStatus['cdl_exp'] : ''}</b>
        //     </Col>
        //   </Row> */}
        // </div>
        <div>
        <Card>
          <div className='row'>
            <div className='col-12 col-md-12 col-xl-12'>
              <Table dataSource={driverRecentResponse} columns={columns} />
            </div>
          </div>
        </Card>
      </div>
      ) : (
        <Row>
          <Col span={10}></Col>
          <Col span={8}>
            <Space size='middle' style={{ marginTop: 50 }}>
              <Spin size='large' />
            </Space>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default DriversQualificationFront;
